module.exports = __webpack_public_path__ + "img/changeSuccess.3ea3b653.png";